import url from 'url';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Component } from 'react';

import { BaseLoader } from '../Loader';
import isSubscriptionRenewable from '../../utils/subscription/isSubscriptionRenewable';
import subscribedThroughWeb from '../../utils/subscription/subscribedThroughWeb';
import hasActiveSubscription from '../../utils/subscription/hasActiveSubscription';
import getLoginRedirect from '../../utils/auth/getLoginRedirect';
import getCouponRedirect from '../../utils/subscription/getCouponRedirect';
import { isSubscribePairPath } from '../../utils/auth/pairAuthFlowHelpers';
import { PAYMENT_PATH, RENEW_PATH } from '../../constants/paths';
import { PAYMENT_FLOW } from '../../constants/subscription/flow';
import { selectSubscriptionProviderName } from '../../selectors/me';
import PairingSubscribeLoader from '../auth/pairing/PairingSubscribeLoader';
import SubscribeLoader from './SubscribeLoader';

// exported for unit testing
export class SubscribeRoute extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    subscription: PropTypes.object.isRequired,
    me: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    const { history, location } = props;
    const onSubscribePair = isSubscribePairPath(location?.pathname);

    const routeTo = this.determineRoute(onSubscribePair);
    if (routeTo) {
      history.replace(routeTo);
    }
    this.state = {
      routeTo,
      onSubscribePair,
    };
  }

  determineRoute(onSubscribePair) {
    const { auth, me, subscription, location } = this.props;

    const loginRedirect = getLoginRedirect(
      auth,
      location,
      !onSubscribePair ? PAYMENT_FLOW : '',
    );
    if (loginRedirect) {
      return url.format(loginRedirect);
    }

    const couponRedirect = getCouponRedirect(me, location);
    if (couponRedirect) {
      return url.format(couponRedirect);
    }

    const hasActiveSub = hasActiveSubscription(me);
    const providerName = selectSubscriptionProviderName({ me });
    const isSubscribedThroughWeb = subscribedThroughWeb(providerName);

    if (onSubscribePair || (!hasActiveSub && !isSubscribedThroughWeb)) {
      return null;
    }

    const pathname = isSubscriptionRenewable({ me, subscription })
      ? RENEW_PATH
      : PAYMENT_PATH;

    return url.format({
      pathname,
      search: location.search,
    });
  }

  render() {
    const { onSubscribePair, routeTo } = this.state;
    const componentToRender = onSubscribePair ? (
      <PairingSubscribeLoader {...this.props} />
    ) : (
      <SubscribeLoader {...this.props} />
    );

    return routeTo ? <BaseLoader /> : componentToRender;
  }
}

export function mapStateToProps(state) {
  const { auth, me, subscription } = state;
  return {
    auth,
    me,
    subscription,
  };
}

export default connect(mapStateToProps)(SubscribeRoute);
